import type { ErrorComponentProps } from '@tanstack/react-router'
import { AlertTriangleIcon } from 'lucide-react'

import { Button } from '#components/ui/button'

function isPageLoadError(error: unknown): boolean {
  if (!error || typeof error !== 'object' || !('message' in error)) return false
  if (typeof error.message !== 'string') return false

  return /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Loading (?:CSS )?chunk .+ failed|Unable to preload CSS/i.test(
    error.message
  )
}

export const ErrorComponent = ({ error }: Pick<ErrorComponentProps, 'error'>) => {
  const pageLoadFailed = isPageLoadError(error)

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-6 bg-gray-50 px-4 text-center">
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-red-100 text-red-600">
        <AlertTriangleIcon size={40} />
      </div>

      <div className="flex flex-col items-center gap-2">
        <h1 className="text-2xl font-bold text-gray-900">
          {pageLoadFailed
            ? 'Impossible de charger cette page'
            : 'Oups ! Une erreur s’est produite !'}
        </h1>
        <p className="max-w-md text-gray-600">Que faire ?</p>
        <p className="max-w-lg text-gray-600">
          {pageLoadFailed
            ? 'Une nouvelle version de l’application est peut-être disponible, ou votre connexion a été interrompue. Actualisez la page pour continuer. Si le problème persiste, vérifiez votre connexion puis contactez le support.'
            : 'Veuillez rafraîchir la page. Si le problème persiste essayez de vous déconnecter puis de vous reconnecter. En cas d’échec, merci de contacter le support.'}
        </p>
      </div>

      <Button
        onClick={() => {
          window.location.reload()
        }}
        size="lg"
        className="mt-2"
      >
        {pageLoadFailed ? 'Actualiser' : 'Retour à l’accueil'}
      </Button>
    </div>
  )
}
